module.exports = require("@material-ui/icons/AddCircle");


//////////////////
// WEBPACK FOOTER
// external "@material-ui/icons/AddCircle"
// module id = 293
// module chunks = 0